// extracted by mini-css-extract-plugin
export default {"firmateckning":"Firmateckning_firmateckning__CvI+w"};